import HInput from "../../../components/custom/input/input/Input";

const TimeSelector = ({ value, onChange, fields, stepIndex = "", className = "" }) => {
    const handleInputChange = (fieldKey, e) => {
        const val = e.target.value;
        const field = fields.find((f) => f.key === fieldKey);
        if (!field) return;

        if (val === "" || /^\d+$/.test(val)) {
            let num = val === "" ? field.min : parseInt(val, 10);
            num = Math.max(field.min, Math.min(num, field.max));

            onChange({ ...value, [fieldKey]: num });
        }
    };

    const inputClassName = "text-center interval-number-input hs-input-number-small";

    return (
        <div className={`d-flex align-items-center gap-3 flex-wrap ${className}`}>
            {fields.map((field, idx) => (
                <div key={field.key} className="d-flex align-items-center gap-2">
                    <HInput
                        tabIndex={`${stepIndex}${idx + 1}`}
                        variant="default"
                        type="number"
                        min={field.min}
                        max={field.max}
                        placeholder="0"
                        value={value[field.key] ?? 0}
                        onChange={(e) => handleInputChange(field.key, e)}
                        customClasses={inputClassName}
                    />
                    <div className="text-muted small text-nowrap">{field.label}</div>
                </div>
            ))}
        </div>
    );
};

export default TimeSelector;
